import { api } from '@/helpers/core'
import { AxiosResponse } from "axios"

export interface Rule {
	name: string
	code: string
}

export interface Ruleset {
	name: string
	rules: string[]
}

export interface Field {
	type: string
	name: string
	code: string
}

export default {
	getRules (): Promise<AxiosResponse<Rule[]>> {
		return api.get('/settings/rules/')
	},
	updateRule (rule: Rule): Promise<AxiosResponse<Rule>> {
		return api.post('/settings/rules/', rule)
	},
	deleteRule (rule: Rule): Promise<AxiosResponse<void>> {
		return api.post('/settings/rules/delete', rule)
	},
	getRulesets (): Promise<AxiosResponse<Ruleset[]>> {
		return api.get('/settings/rulesets/')
	},
	updateRuleset (ruleset: Ruleset): Promise<AxiosResponse<Ruleset>> {
		return api.post('/settings/rulesets/', ruleset)
	},
	deleteRuleset (ruleset: Ruleset): Promise<AxiosResponse<void>> {
		return api.post('/settings/rulesets/delete', ruleset)
	},
	include ({ rulesetName, name }: { rulesetName: string, name: string }): Promise<AxiosResponse<string[]>> {
		return api.post('/settings/rulesets/include', { rulesetName, name })
	},
	replace ({ rulesetName, name, value }: { rulesetName: string, name: string, value: number | null }): Promise<AxiosResponse<string[]>> {
		return api.post('/settings/rulesets/replace', { rulesetName, name, value })
	},
	getFields (): Promise<AxiosResponse<Field[]>> {
		return api.get('/settings/fields/')
	},
	updateField (field: Field): Promise<AxiosResponse<Field>> {
		return api.post('/settings/fields/', field)
	},
	deleteField (field: Field): Promise<AxiosResponse<void>> {
		return api.post('/settings/fields/delete', field)
	}
}
